module.exports = __webpack_public_path__ + "static/media/house.f75107f6.jpg";